



















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const giftCardModule = namespace("giftCard");

@Component
export default class Detail extends Vue {
  active: number = 1;
  detail: any = {};
  id:any =''
  @giftCardModule.State("successInfo") successInfo!: any;

  mounted() {
    this.id = this.$route.query;
    this.getInfo()
  }

  async getInfo() {
    const { success } = await this.$store.dispatch(
      'giftCard/writeoffDetail',
      {
        flowId: this.$route.query.id
      }
    )
    if (success) {
        this.detail = success.data
    }
  }
}
